import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;

export class SpaceServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 查询所有数据接口
  public getAllData(opts: any) {
    opts.currentSpaceFollowing = true;
    const url = serverUrl + '/api/sysManage/sysSpace/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取单个数据
  public getData(id: string) {
    const url = serverUrl + '/api/sysManage/sysSpace/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 空间初始化
  public addData(opts: object) {
    const url = serverUrl + '/api/sysManage/sysSpace/init';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editData(opts: object) {
    const url = serverUrl + '/api/sysManage/sysSpace';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 修改 树 的 数据
  public editTreeData(opts: object, menuIds: []) {
    console.log(opts, 46);
    const url = serverUrl + '/api/sysManage/sysMenu/alterSpaceMenu' + changePostParam(opts);
    return this.rSerivce.serverObj.post(url, menuIds);
  }

  // 删除空间
  public deleteData(id: string) {
    const url = serverUrl + '/api/sysManage/sysSpace';
    return this.rSerivce.serverObj.delete(url, {
      params: { idList: id },
    });
  }
  // 数据隔离
  public getTopDeptId() {
    const url = serverUrl + '/api/sysManage/sysSpaceConfig/getOneByCode/currentSpace/data.auth.topDept';
    return this.rSerivce.serverObj.get(url);
  }
}
